//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    body: String,
    indent: {
      default: true,
      type: Boolean
    }
  }
}
